export default class StringUtils {
    public static readonly isEqualsIgnoreCase = makeOverride(isEqualsIgnoreCaseInner);
    public static readonly isEquals = makeOverride(p => m => _.isEqual(p, m));
    public static readonly containsIgnoreCase = makeOverride(containsIgnoreCaseInner);
    public static readonly isTrue = StringUtils.isEqualsIgnoreCase('true');
    public static readonly isFalse = StringUtils.isEqualsIgnoreCase('false');
}

type Matcher<T> = (match: Nullable<string>) => T;
type Operation<T> = (pattern: string) => Matcher<T>;
export type OperationOverride<T> = {
    (): (pattern: Nullable<string>, match: Nullable<string>) => T;
    (pattern: Nullable<string>): Matcher<T>;
    (pattern: Nullable<string>, match: Nullable<string>): T;
};

function isEqualsIgnoreCaseInner(pattern: string): Matcher<boolean> {
    if (_.isNil(pattern)) {
        return _.isNil;
    }
    const upperPattern = pattern.toUpperCase();
    return (match: Nullable<string>) => !_.isNil(match) && match.toUpperCase() === upperPattern;
}

function containsIgnoreCaseInner(pattern: string): Matcher<boolean> {
    if (_.isNil(pattern)) {
        return _.stubFalse;
    }
    const upperPattern = pattern.toUpperCase();
    return (match: Nullable<string>) => !_.isNil(match) && match.toUpperCase().contains(upperPattern);
}

function makeOverride<T>(fn: Operation<T>): OperationOverride<T> {
    return ((...args: [] | [string] | [string, string]) => {
        if (args.length === 0) {
            return (s: string, s1: string) => fn(s)(s1);
        }
        if (args.length === 1) {
            return fn(args[0]);
        }
        return fn(args[0])(args[1]);
    }) as OperationOverride<T>;
}
